import Vue from 'vue'
// import store from '../../store'

export default {
  uploadDocuments (formData) {
    return Vue.http.post(window.API_URL + 'doctors/customer/documents', formData)
  },
  uploadLabDocs (formData, data) {
    var url = ''
    if (data.documentType === 'Lab Report') {
      url = window.API_URL + 'doctors/lab_reports'
    } else {
      url = window.API_URL + 'doctors/prescriptions'
    }
    return Vue.http.post(url, formData)
  },
  fetch: function (doctype, docid) {
    let type = 'medical_records'
    if (doctype === 'Prescription') {
      type = 'prescriptions'
    }
    return Vue.http.get(window.API_URL + 'doctors/' + type + '/' + docid + '/download')
  },
  getCustomerUploadedFiles (customerId) {
    return Vue.http.get(window.API_URL + 'doctors/customers/' + customerId + '/consultation_uploads')
  }
}



// WEBPACK FOOTER //
// ./src/api/customer/document.js